import { type Dispatch, type SetStateAction } from 'react';

export enum Ellipsis {
  START = 'start-ellipsis',
  END = 'end-ellipsis',
}

export enum Navigation {
  PREVIOUS = 'previous',
  NEXT = 'next',
}

export type PaginationProps = {
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  total: number;
  dense?: boolean;
  className?: string;
  isMinimized?: boolean;
};

export type PageButtonProps = Pick<PaginationProps, 'dense' | 'total' | 'setCurrentPage'> & {
  isActive?: boolean;
  page: Ellipsis | number | Navigation;
};
